import { BaseKeyframeTween } from "./base-tween";
import Network from "../../miniviews/network";
import RenderManager from "../../rendering/render-manager";

// ----------------------------------------
//                  TRANSFORM
// ----------------------------------------
class TweenTransform {
    /**
     * 
     * @param {KeyframeTweenTransform} state 
     * @param {KeyframeTweenTransform} target 
     */
    constructor(state, target) {
        const v1 = new THREE.Vector3(target.posX, target.posY, target.posZ);
        const v2 = new THREE.Vector3(target.tarX, target.tarY, target.tarZ);

        this.posX = v1.x;
        this.posY = v1.y;
        this.posZ = v1.z;

        this.tarX = v2.x;
        this.tarY = v2.y;
        this.tarZ = v2.z;

        this.onStart = () => {
            Network.transferEnabled = false;

            const { posX, posY, posZ } = state;
            const { tarX, tarY, tarZ } = state;

            RenderManager.activeCamera.position.set(posX, posY, posZ);
            RenderManager.activeCamera.lookAt(tarX, tarY, tarZ);

            if (Q3.controls.isFPSControls) Q3.controls.deactivate();
        };

        this.onUpdate = () => {
            const { posX, posY, posZ } = state;
            const { tarX, tarY, tarZ } = state;

            RenderManager.activeCamera.position.set(posX, posY, posZ);

            setControlsTarget(Q3.controls, state);
            if (Q3.controls === Q3.objectRotationControls) {
                setControlsTarget(Q3.physicalCameraControls, state);
            }

            RenderManager.activeCamera.lookAt(tarX, tarY, tarZ);

            RenderManager.activeCamera.update = true;
        };

        this.onComplete = () => {;
            RenderManager.activeCamera.update = true;
            Q3.controls.update();
            RenderManager.activeCamera.lookAt(Q3.controls.target);

            Network.transferEnabled = true;

            if (Q3.controls.isFPSControls) Q3.controls.activate();
        };
    }
}

function setControlsTarget(controls, state) {
    let { tarX, tarY, tarZ } = state;
    controls.target.set(tarX, tarY, tarZ);
}

class KeyframeTweenTransform extends BaseKeyframeTween {
    constructor({
        position = new THREE.Vector3(),
        target = new THREE.Vector3(),
    } = {}) {
        super();

        this.posX = position.x;
        this.posY = position.y;
        this.posZ = position.z;

        this.tarX = target.x;
        this.tarY = target.y;
        this.tarZ = target.z;
    }

    /**
     * 
     * @param {SlideSettings} slide 
     */
    fromSlide(slide) {
        this.posX = slide.position.x;
        this.posY = slide.position.y;
        this.posZ = slide.position.z;

        this.tarX = slide.target.x;
        this.tarY = slide.target.y;
        this.tarZ = slide.target.z;

        return this;
    }

    /**
     * 
     * @param {KeyframeTweenTransform} target 
     * @param {number} time 
     */
    tweenTo(target, time) {
        const tween = new TweenTransform(this, target);

        return new TweenMax(this, time, tween);
    }
}

export { TweenTransform, KeyframeTweenTransform };